// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GtinList_wrapper__1bAJd"};